import React from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function InProgress() {
    const classes = useStyles();

    return (
        <div>
            <GridContainer>
                <GridItem xs={4} sm={3}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Devices</h4>
                        </CardHeader>
                        <CardBody>
                            <ul>
                                <li>All Phones</li>
                                <li>iPhone</li>
                                <li>Android</li>
                                <li>Smart Watches</li>
                                <li>Tablets</li>
                                <li>Mobile Modems</li>
                            </ul>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={4} sm={3}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Plans</h4>
                        </CardHeader>
                        <CardBody>
                            <ul>
                                <li>Business Flex</li>
                                <li>Plans with Phones</li>
                                <li>SIM Only Plans</li>
                                <li>Mobile Broadband Plans</li>
                                <li>Add-ons</li>
                                <li>Vodafone Passes</li>
                                <li>Vodafone NumberSync&trade;</li>
                            </ul>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={4} sm={3}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Forms and Tools</h4>
                        </CardHeader>
                        <CardBody>
                            <ul>
                                <li>NSA - Company</li>
                                <li>NSA - Consumer and Sole Trader</li>
                                <li>Business Flex EPR Tool</li>
                                <li>Bulk NSA</li>
                                <li>CUF</li>
                                <li>CIS</li>
                            </ul>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={4} sm={3}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Links</h4>
                        </CardHeader>
                        <CardBody>
                            <ul>
                                <li>Vodafone</li>
                                <li>Red Source</li>
                                <li>Track Your Order</li>
                                <li>Check Your Coverage</li>
                                <li>ABN Lookup</li>
                                <li>Search ASIC Registers</li>
                            </ul>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
};